<template lang="html">
  <v-container fluid class="mx-auto mb-12" style="max-width: 600px;">

    <div class="text-center mt-2 mb-8">
      <a
        class="d-block py-1"
        href="https://www.thepot.se"
        target="_blank"
      >
        <img
          :src="'../web/app-logo'"
          alt="COMPANY LOGO"
          style="max-width: 140px; object-fit: contain;  image-rendering: -webkit-optimize-contrast;"
        >
      </a>
    </div>

    <!-- Select what to book start -->
    <div v-if="calendar.id && !showCreateBooking && (''+express) != 'true'">
      <div class="text-center mb-8" v-if="loadingResources">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>

      <v-card
        v-else-if="!resourcesData"
        class="mx-auto mb-8"
      >
        <v-card-title>
          Kunde inte hämta ytor
        </v-card-title>
        <v-card-text>
          Klicka på knappen nedan för att försöka igen.
        </v-card-text>
        <v-card-title>
          <v-spacer />
          <v-btn color="primary" @click="fetchResources">Hämta ytor</v-btn>
        </v-card-title>
      </v-card>

      <div class="" v-else>
        <div class="body-1 mx-2 mb-8">
          Önskar du boka ett flerdagsevent, kvällsarrangemang eller annan happening? Hör gärna av er på <a href="mailto:hej@thepot.se">hej@thepot.se</a>, vi skräddarsyr mängder av upplevelser.
        </div>

        <v-card
          class="mx-auto mb-8"
          v-ripple
          style="cursor: pointer;"
          @click="onBookResource(null)"
        >
          <v-card-title>
            Hitta ledigt
          </v-card-title>
          <v-card-text>
            <div class="d-flex align-center">
              <div class="flex-grow-1">
                Fyll i antal personer och datum och se vad som är ledigt
              </div>
              <div class="">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <div v-if="boxes.length">
          <div class="headline mb-2 ml-2">
            Boxar
          </div>
          <booking-option
            v-for="resource in boxes"
            :key="resource.id"
            :resource="resource"
            :calendar="calendar"
            @click="onResourceDetail(resource)"
          ></booking-option>
        </div>

        <div class="mt-16">
          <div class="headline mb-2 ml-2">
            Konferensrum
          </div>
          <booking-option
            v-for="resource in resourcesData.Konferensrum"
            :key="resource.id"
            :resource="resource"
            :calendar="calendar"
            @click="onResourceDetail(resource)"
          ></booking-option>
        </div>

        <div class="mt-4">
          <booking-option
            v-for="resource in resourcesData.groups"
            :key="resource.title"
            :resource="resource"
            :calendar="calendar"
            @click="onResourceDetail(resource)"
          ></booking-option>
        </div>

        <div class="mt-16">
          <div class="headline mb-2 ml-2">
            Övriga ytor
          </div>
          <booking-option
            v-for="resource in resourcesData.Yta"
            :key="resource.id"
            :resource="resource"
            :calendar="calendar"
            @click="onResourceDetail(resource)"
          ></booking-option>
        </div>
      </div>
    </div>
    <!-- Select what to book end -->

    <!-- Create booking start -->
    <div v-else>
      <div class="mb-4" v-if="!resourceIds">
        <v-btn text @click="onBack">
          <v-icon left>mdi-arrow-left</v-icon>Tillbaka
        </v-btn>

        <div class="text--secondary mt-4 ml-4">
          {{bookingTitle}}
        </div>
      </div>
      <div class="mb-4" v-else>
        <v-btn text @click="$router.push({name: $route.name, params: $route.params})">
          <v-icon left>mdi-arrow-left</v-icon>Byt rum
        </v-btn>
      </div>

      <public-create-booking
        class="mx-auto px-0"
        :calendar-id="calendarId"
        :express="(''+express) == 'true'"
        :resourceIds="resourceIds"
        appUrl="dynapp-paraply-thepot-switcher://"
        installUrl="https://u.wip.se/app/thepot"
        :defaultItem="defaultItem"
        :selectResourceType="false"
        :selectEventType="false"
        :customSteps="customStepsAvailable ? customSteps : []"
      >
        <template #complete:buttons="{item}">
          <div v-if="(item.expanded_resources || []).some(r => !!r.salto_id)" class="mb-6">
            Vi har skickat en länk till er för att lägga till nyckel i appen för de ytor ni har bokat. Nyckeln kan kopplas i upp till tre enheter.
          </div>

          <v-btn color="primary" @click="onBack">
            Stäng
          </v-btn>
        </template>
      </public-create-booking>
    </div>
    <!-- Create booking end -->

    <div class="text-center mt-12">
      <router-link :to="{name: 'public-booking-calendar', params: {calendarId: 'default'}}" target="_blank">Bokningskalender</router-link>
    </div>

    <div class="text-center mt-8 mb-12">
      Hitta mer info på <a href="https://www.thepot.se/boka" target="_blank">thepot.se</a>
    </div>

    <!-- Resource detail dialog start -->
    <v-dialog
      max-width="500"
      v-model="resourceDetailDialog"
      scrollable
    >
      <v-card>
        <v-card-title>
          {{resourceDetail.title}}
        </v-card-title>
        <v-card-text>
          <booking-resource
            :calendar="calendar"
            :item="resourceDetail"
          ></booking-resource>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="mr-2" text @click="resourceDetailDialog = false">Stäng</v-btn>
          <v-btn color="primary" @click="onBookResource(resourceDetail)">Boka</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Resource detail dialog end -->
  </v-container>
</template>

<script>
import {PublicCreateBooking, BookingResource} from 'dync-booking';
import {apiUrl} from '@dynapp/wc-api-generic';
import axios from 'axios';
import CustomBookingStep from './CustomBookingStep.vue';
import BookingOption from './BookingOption.vue';

export default {
  name: 'CreateBooking',
  props: {
    calendarId: {
      default: 'default'
    },
    express: {
      default: ''
    },
    resourceIds: {}
  },
  data() {
    return {
      resourcesData: null,
      loadingResources: false,
      resourceDetail: {},
      resourceDetailDialog: false,
      showCreateBooking: false,
      defaultItem: {
        contact: {}
      },
      bookingTitle: '',
      customSteps: [
        {
          title: 'Options',
          component: CustomBookingStep
        }
      ],
      customStepsAvailable: true
    };
  },
  watch: {
    resourceIds() {
      this.resourceDetailDialog = false;
      this.showCreateBooking = false;
      this.fetchResources();
    }
  },
  computed: {
    calendar() {
      if (this.$store.getters.isLoadingFor('booking-public-calendar.read')) {
        return {};
      }
      return this.$store.getters[`bookings-public/${this.calendarId}/calendar`] || {};
    },
    boxes() {
      return this.resourcesData.Box.filter((box) => box.title != 'Cube');
    },
  },
  methods: {
    fetchResources() {
      this.loadingResources = true;
      axios.get(apiUrl({dataObject: 'custombooking'}, `booking-resources/${this.calendarId}`)).then(
        (resp) => {
          this.loadingResources = false;
          this.resourcesData = resp.data;
          if (this.resourceIds) {
            this.onBookResource();
          }
        },
        () => {
          this.loadingResources = false;
        }
      )
    },
    onResourceDetail(resource) {
      this.resourceDetail = resource;
      this.resourceDetailDialog = true;
    },
    onBookResource(resource) {
      this.resourceDetailDialog = false;
      this.showCreateBooking = true;
      if (!resource) {
        this.customStepsAvailable = true;
        this.defaultItem = {
          resources: [
            {
              title: 'Konferensrum',
              demands: [
                {
                  type: 'resource_value',
                  property: 'type',
                  value: 'Konferensrum'
                }
              ]
            }
          ],
          contact: {}
        };
        this.bookingTitle = 'Hitta något ledigt';
      } else {
        if (resource.id) {
          var isBox = resource.type == 'Box';
          this.customStepsAvailable = isBox ? false : true;
          this.defaultItem = {
            guests: isBox ? 1 : null,
            resources: [
              {
                title: resource.type,
                demands: [
                  {
                    type: 'resource_value',
                    property: 'id',
                    value: resource.id
                  }
                ]
              }
            ],
            contact: {}
          };
        } else {
          this.customStepsAvailable = true;
          this.defaultItem = {
            resources: [
              {
                title: 'Paket',
                demands: [
                  {
                    type: 'resource_value_in',
                    property: 'id',
                    value: resource.resources
                  },
                  {
                    type: 'resources_count',
                    value: resource.resources.length
                  },
                  {
                    type: 'resources_min_value',
                    property: 'guests',
                    value: 0,
                    allow_overflow: true
                  }
                ]
              }
            ],
            contact: {}
          };
        }
        this.bookingTitle = 'Boka ' + resource.title;
      }
    },
    onBack() {
      this.showCreateBooking = false;
    }
  },
  created() {
    this.fetchResources();
  },
  components: {
    PublicCreateBooking,
    BookingOption,
    BookingResource
  }
}
</script>

<style lang="scss" scoped>
</style>
